import { createFileRoute } from "@tanstack/react-router";
import { pageSeo } from "@/lib/seo";
import { FinanceCalculatorEmbed } from "@/components/financing/finance-calculator-embed";

const PATH = "/finance-loan-calculator";
const TITLE = "Loan Repayment Calculator | CRS Energy";
const DESCRIPTION =
  "Model your monthly payments on a loan with Ideal4Finance across Wales and the South West of England. Choose an APR, enter a price and term, then get the figures emailed to you.";

export const Route = createFileRoute("/finance-loan-calculator")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "website",
    }),
  }),
  component: FinanceLoanCalculatorPage,
});

function FinanceLoanCalculatorPage() {
  return (
    <main className="bg-background min-h-screen">
      <section className="container-page py-8 md:py-12">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            Loan Repayment Calculator
          </h1>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            Estimate the monthly payment on home improvement finance. Choose an APR,
            enter a price and term, then have the figures emailed to you.
          </p>
        </div>

        <div className="mt-6">
          <FinanceCalculatorEmbed sourcePage={PATH} idPrefix="loan-calc" />
        </div>
      </section>
    </main>
  );
}
